export const aiHelper = (content = '') => {
  const aiBlocks = content?.match(
    /<ai-personalized-block><\/ai-personalized-block>/
  );
  let beforeText = '';
  let afterText = '';
  if (aiBlocks?.length) {
    beforeText = content?.substring(0, aiBlocks?.index) || '';
    afterText =
      content?.substring(aiBlocks?.index + aiBlocks?.[0]?.length) || '';
  }

  return { beforeText, afterText, aiBlocks };
};
